<template>
  <ol>
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsOne`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsTwo`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsThree`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsFour`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsFive`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsSix`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsSeven`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsEight`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsNine`) }}</li>
    <br />
    <li>{{ $t(`message.slideSevenTeenPlanningFactorsTen`) }}</li>
  </ol>
</template>

<script>
export default {
  name: "PlanningFactors"
};
</script>
